import { defineComponent, computed } from 'vue';
import { useRouter, RouterView } from 'vue-router';
import { useStore } from 'vuex';
import { AuthTemplateContainer, HealthCheckContainer, MobileTemplateContainer, WeatherContainer, } from '@hems/container';
import { PageTemplate } from '@/components';
import { isWeather } from '@/config/constants';
import { MainTemplateContainer } from '@/containers';
export default defineComponent({
    name: 'App',
    components: {
        MainTemplateContainer,
        AuthTemplateContainer,
        PageTemplate,
        RouterView,
        HealthCheckContainer,
        MobileTemplateContainer,
        WeatherContainer,
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const isMobile = location.href.includes('/mobile/');
        const baseDeviceInfo = computed(() => store.state.device.baseDeviceInfo ?? null);
        const onClickNavigation = (e, path) => {
            router.push({
                name: path,
            });
        };
        const goHome = () => {
            router.push({
                name: 'Home',
            });
        };
        return {
            isMobile,
            isWeather,
            baseDeviceInfo,
            goHome,
            onClickNavigation,
        };
    },
});
